// auth.interceptor.ts
import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const accessToken = localStorage.getItem('admin_access_token');
        const idToken = localStorage.getItem('x-id-token');

        const isCognito = request.url.includes('amazoncognito.com') || request.url.includes('cognito-idp');

        if (!accessToken || isCognito) {
            return next.handle(request);
        }

        const cloned = request.clone({
            setHeaders: {
                Authorization: `Bearer ${accessToken}`,
                "x-id-token": `${idToken}`,
            },
        });

        return next.handle(cloned);
    }
}
